import { __assign, __awaiter, __generator } from "tslib";
import { NetworkService } from '../Services/NetworkService';
var UserRepo = /** @class */ (function () {
    function UserRepo() {
    }
    Object.defineProperty(UserRepo, "login", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (store, body) {
            return __awaiter(this, void 0, void 0, function () {
                var auth;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, NetworkService.request(store, 'login', 'POST', __assign(__assign({}, body), { type: 'customer' }))];
                        case 1:
                            auth = _a.sent();
                            return [2 /*return*/, auth];
                    }
                });
            });
        }
    });
    Object.defineProperty(UserRepo, "signup", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (store, body) {
            return __awaiter(this, void 0, void 0, function () {
                var auth;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, NetworkService.request(store, 'register', 'POST', __assign(__assign({}, body), { role: 'customer' }), { shouldShowMessage: true })];
                        case 1:
                            auth = _a.sent();
                            return [2 /*return*/, auth];
                    }
                });
            });
        }
    });
    Object.defineProperty(UserRepo, "sendForgotPasswordEmail", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (store, body) {
            return __awaiter(this, void 0, void 0, function () {
                var forgot;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, NetworkService.request(store, 'customer/forgot-password', 'POST', body, { shouldShowMessage: true })];
                        case 1:
                            forgot = _a.sent();
                            return [2 /*return*/, forgot];
                    }
                });
            });
        }
    });
    Object.defineProperty(UserRepo, "sendResetPassword", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (store, body) {
            return __awaiter(this, void 0, void 0, function () {
                var reset;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, NetworkService.request(store, 'customer/change-password', 'POST', body, {
                                shouldShowMessage: true,
                            })];
                        case 1:
                            reset = _a.sent();
                            return [2 /*return*/, reset];
                    }
                });
            });
        }
    });
    Object.defineProperty(UserRepo, "logout", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (store) {
            return __awaiter(this, void 0, void 0, function () {
                var loggedOut;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, NetworkService.request(store, 'auth/logout', 'POST', {})];
                        case 1:
                            loggedOut = _a.sent();
                            return [2 /*return*/, loggedOut];
                    }
                });
            });
        }
    });
    Object.defineProperty(UserRepo, "verifyEmail", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (store, id) {
            return __awaiter(this, void 0, void 0, function () {
                var verify;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, NetworkService.request(store, "member-management/approvalbymember/" + id, 'PUT')];
                        case 1:
                            verify = _a.sent();
                            return [2 /*return*/, verify];
                    }
                });
            });
        }
    });
    return UserRepo;
}());
export { UserRepo };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiVXNlclJlcG8uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvUmVwb3NpdG9yaWVzL1VzZXJSZXBvLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFDQSxPQUFPLEVBQUMsY0FBYyxFQUFDLE1BQU0sNEJBQTRCLENBQUM7QUFHMUQ7SUFBQTtJQTRDQSxDQUFDOzs7OztlQTNDQyxVQUFtQixLQUFlLEVBQUUsSUFBb0I7Ozs7O2dDQUN6QyxxQkFBTSxjQUFjLENBQUMsT0FBTyxDQUFDLEtBQUssRUFBRSxPQUFPLEVBQUUsTUFBTSx3QkFDM0QsSUFBSSxLQUNQLElBQUksRUFBRSxVQUFVLElBQ2hCLEVBQUE7OzRCQUhJLElBQUksR0FBRyxTQUdYOzRCQUNGLHNCQUFPLElBQUksRUFBQzs7OztTQUNiOzs7Ozs7ZUFFRCxVQUFvQixLQUFlLEVBQUUsSUFBcUI7Ozs7O2dDQUMzQyxxQkFBTSxjQUFjLENBQUMsT0FBTyxDQUN2QyxLQUFLLEVBQ0wsVUFBVSxFQUNWLE1BQU0sd0JBRUQsSUFBSSxLQUNQLElBQUksRUFBRSxVQUFVLEtBRWxCLEVBQUMsaUJBQWlCLEVBQUUsSUFBSSxFQUFDLENBQzFCLEVBQUE7OzRCQVRLLElBQUksR0FBRyxTQVNaOzRCQUNELHNCQUFPLElBQUksRUFBQzs7OztTQUNiOzs7Ozs7ZUFFRCxVQUFxQyxLQUFlLEVBQUUsSUFBUzs7Ozs7Z0NBQzlDLHFCQUFNLGNBQWMsQ0FBQyxPQUFPLENBQUMsS0FBSyxFQUFFLDBCQUEwQixFQUFFLE1BQU0sRUFBRSxJQUFJLEVBQUUsRUFBQyxpQkFBaUIsRUFBRSxJQUFJLEVBQUMsQ0FBQyxFQUFBOzs0QkFBakgsTUFBTSxHQUFHLFNBQXdHOzRCQUN2SCxzQkFBTyxNQUFNLEVBQUM7Ozs7U0FDZjs7Ozs7O2VBRUQsVUFBK0IsS0FBZSxFQUFFLElBQW9COzs7OztnQ0FDcEQscUJBQU0sY0FBYyxDQUFDLE9BQU8sQ0FBQyxLQUFLLEVBQUUsMEJBQTBCLEVBQUUsTUFBTSxFQUFFLElBQUksRUFBRTtnQ0FDMUYsaUJBQWlCLEVBQUUsSUFBSTs2QkFDeEIsQ0FBQyxFQUFBOzs0QkFGSSxLQUFLLEdBQUcsU0FFWjs0QkFDRixzQkFBTyxLQUFLLEVBQUM7Ozs7U0FDZDs7Ozs7O2VBRUQsVUFBb0IsS0FBZTs7Ozs7Z0NBQ2YscUJBQU0sY0FBYyxDQUFDLE9BQU8sQ0FBQyxLQUFLLEVBQUUsYUFBYSxFQUFFLE1BQU0sRUFBRSxFQUFFLENBQUMsRUFBQTs7NEJBQTFFLFNBQVMsR0FBRyxTQUE4RDs0QkFDaEYsc0JBQU8sU0FBUyxFQUFDOzs7O1NBQ2xCOzs7Ozs7ZUFFRCxVQUF5QixLQUFlLEVBQUUsRUFBVTs7Ozs7Z0NBQ25DLHFCQUFNLGNBQWMsQ0FBQyxPQUFPLENBQUMsS0FBSyxFQUFFLHdDQUFzQyxFQUFJLEVBQUUsS0FBSyxDQUFDLEVBQUE7OzRCQUEvRixNQUFNLEdBQUcsU0FBc0Y7NEJBQ3JHLHNCQUFPLE1BQU0sRUFBQzs7OztTQUNmOztJQUNILGVBQUM7QUFBRCxDQUFDLEFBNUNELElBNENDIn0=